import { __assign, __rest } from "tslib";
import React from 'react';
import VeltRecordingPreviewStepsDialogMicButtonOffWireframe from './VeltRecordingPreviewStepsDialogMicButtonOffWireframe/VeltRecordingPreviewStepsDialogMicButtonOffWireframe';
import VeltRecordingPreviewStepsDialogMicButtonOnWireframe from './VeltRecordingPreviewStepsDialogMicButtonOnWireframe/VeltRecordingPreviewStepsDialogMicButtonOnWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltRecordingPreviewStepsDialogMicButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-mic-button-wireframe", __assign({}, transformedProps), children));
};
VeltRecordingPreviewStepsDialogMicButtonWireframe.On = VeltRecordingPreviewStepsDialogMicButtonOnWireframe;
VeltRecordingPreviewStepsDialogMicButtonWireframe.Off = VeltRecordingPreviewStepsDialogMicButtonOffWireframe;
export default VeltRecordingPreviewStepsDialogMicButtonWireframe;
